// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { Amulet } from '@daml.js/splice-amulet/lib/Splice/Amulet';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../contexts/ModuleContext';
import TemplateContract from '../../../utils/TemplateContract';

const useCoins: () => UseQueryResult<TemplateContract<Amulet>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const party = useModuleParty();

  return useQueryWithOffset({
    queryKey: ['queryCoins', party],
    queryFn: async (_, offset) => {
      return ledgerApi.queryCoins(offset, party);
    },
  });
};

export default useCoins;
